export const AUTH_REDIRECTS = {
  unauthorized: "/sign-in",
  authorized: "/estates",
} as const;

export const AUTH_QUERY_PARAMS = {
  clearAuth: "clear_auth",
} as const;

export const AUTH_ROUTE_GROUPS = {
  guestOnly: ["/", "/sign-in", "/sign-up"],
  protected: ["/estates", "/analytics", "/profile"],
} as const;

const isExactRouteMatch = (pathname: string, route: string) => {
  return pathname === route;
};

const isNestedRouteMatch = (pathname: string, route: string) => {
  return route !== "/" && pathname.startsWith(`${route}/`);
};

export const matchesRouteGroup = (pathname: string, routes: readonly string[]) => {
  return routes.some(route => isExactRouteMatch(pathname, route) || isNestedRouteMatch(pathname, route));
};
